import { DateTagNameEnum } from '@ztechapps/common.utils'

export const dateTimeZoneOptions = [
  { value: DateTagNameEnum.STARTOFYEAR, label: 'Start of year' },
  { value: DateTagNameEnum.ENDOFYEAR, label: 'End of year' },
  { value: DateTagNameEnum.STARTOFMONTH, label: 'Start of month' },
  { value: DateTagNameEnum.ENDOFMONTH, label: 'End of month' },
  { value: DateTagNameEnum.STARTOFWEEK, label: 'Start of week' },
  { value: DateTagNameEnum.ENDOFWEEK, label: 'End of week' },
  { value: DateTagNameEnum.STARTOFDAY, label: 'Start of day' },
  { value: DateTagNameEnum.ENDOFDAY, label: 'End of day' },
  { value: DateTagNameEnum.CURRENT, label: 'Current date and time' },
]
